import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/documents')({
  staticData: { breadcrumb: 'Documents', breadcrumbKey: 'K_BREADCRUMB_DOCUMENTS' },
});
